export default "/base.719e6bcadb11d42a0d5ce6cb817ba9a8.svg";